import { z } from 'zod';

import { schemaEuropaceFirma } from './Firma.schema';
import { regex_iso_date } from '../../../../utils/regex.utils';
import { schemaBigDecimal } from '../../../../utils/schema.utils';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-import-api/#freiberufler

	{
		"berufsbezeichnung": String,
		"firma": Firma,
		"selbststaendigSeit": "YYYY-MM-DD",
		"nettoeinkommenJaehrlich": schemaBigDecimal,
		"bruttoEinkommenLaufendesJahr": schemaBigDecimal,
		"einkommenssteuerLaufendesJahr": schemaBigDecimal,
		"abschreibungenLaufendesJahr": schemaBigDecimal,
		"bruttoEinkommenLetztesJahr": schemaBigDecimal,
		"einkommenssteuerLetztesJahr": schemaBigDecimal,
		"abschreibungenLetztesJahr": schemaBigDecimal,
		"einkommenssteuerVor2Jahren": schemaBigDecimal,
		"bruttoEinkommenVor2Jahren": schemaBigDecimal,
		"abschreibungenVor2Jahren": schemaBigDecimal,
		"bruttoEinkommenVor3Jahren": schemaBigDecimal,
		"einkommenssteuerVor3Jahren": schemaBigDecimal,
		"abschreibungenVor3Jahren": schemaBigDecimal,
	}

*/

export const schemaEuropaceFreiberufler = z.object({
    abschreibungenLaufendesJahr: z.optional(schemaBigDecimal),
    abschreibungenLetztesJahr: z.optional(schemaBigDecimal),
    abschreibungenVor2Jahren: z.optional(schemaBigDecimal),
    abschreibungenVor3Jahren: z.optional(schemaBigDecimal),
    berufsbezeichnung: z.optional(z.string()),
    bruttoEinkommenLaufendesJahr: z.optional(schemaBigDecimal),
    bruttoEinkommenLetztesJahr: z.optional(schemaBigDecimal),
    bruttoEinkommenVor2Jahren: z.optional(schemaBigDecimal),
    bruttoEinkommenVor3Jahren: z.optional(schemaBigDecimal),
    einkommenssteuerLaufendesJahr: z.optional(schemaBigDecimal),
    einkommenssteuerLetztesJahr: z.optional(schemaBigDecimal),
    einkommenssteuerVor2Jahren: z.optional(schemaBigDecimal),
    einkommenssteuerVor3Jahren: z.optional(schemaBigDecimal),
    firma: z.optional(schemaEuropaceFirma),
    nettoeinkommenJaehrlich: z.optional(schemaBigDecimal),
    selbststaendigSeit: z.optional(z.string().regex(regex_iso_date)),
});

export type SchemaEuropaceFreiberufler = z.infer<typeof schemaEuropaceFreiberufler>;
